'use strict';

require('./performance-review-summary.scss');

module.exports = {
  template: require('./performance-review-summary.html'),
  controller: require('./performance-review-summary.controller'),
  controllerAs: 'vm',

  bindings: {
    data: '<',
    me: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-summary/index.js
 ** module id = 276
 ** module chunks = 0
 **/